import React, { useState } from "react";
import { useDropzone, FileRejection } from "react-dropzone";

interface EligibilityDropzoneProps {
  onFile: (file: File) => void;
}

const ACCEPTED_TYPES = {
  "text/csv": [".csv"],
};

const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

const EligibilityDropzone: React.FC<EligibilityDropzoneProps> = ({
  onFile,
}) => {
  const [error, setError] = useState<string | null>(null);

  const onDrop = (acceptedFiles: File[], fileRejections: FileRejection[]) => {
    if (acceptedFiles && acceptedFiles.length > 0) {
      setError(null);
      onFile(acceptedFiles[0]);
    } else if (fileRejections && fileRejections.length > 0) {
      const errorCodes = fileRejections.flatMap((rej) =>
        rej.errors.map((e) => e.code)
      );
      if (errorCodes.includes("file-too-large")) {
        setError("File is too large. Maximum allowed size is 10MB.");
      } else if (errorCodes.includes("too-many-files")) {
        setError("Only one file can be uploaded at a time.");
      } else if (errorCodes.includes("file-invalid-type")) {
        setError("Only .csv files are accepted.");
      } else {
        setError("File rejected. Please check the file and try again.");
      }
    }
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: ACCEPTED_TYPES,
    multiple: false,
    maxFiles: 1,
    maxSize: MAX_FILE_SIZE,
  });

  return (
    <div
      {...getRootProps()}
      className={`border-2 border-dashed rounded-lg p-8 text-center cursor-pointer transition-colors ${
        isDragActive ? "border-blue-500 bg-blue-50" : "border-gray-300"
      }`}
    >
      <input {...getInputProps()} />
      <p className="mb-2">Drag and drop a .csv file here, or click to select</p>
      {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
    </div>
  );
};

export default EligibilityDropzone;
